// Small recovery helpers used only by the Viva payment terminal flow in Receipt.vue.
// Kept isolated so other payment providers (Visma Pay/Bambora, MobilePay, ...) are unaffected.
export default {
  methods: {
    sleep (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    // Races a promise against a timer so a hung request can never block the caller forever.
    withTimeout (promise, ms, timeoutError) {
      return new Promise((resolve, reject) => {
        let settled = false
        const timer = setTimeout(() => {
          if (settled) return
          settled = true
          reject(timeoutError || { timeout: true, errorMessage: this._('The request timed out.') })
        }, ms)
        promise.then((result) => {
          if (settled) return
          settled = true
          clearTimeout(timer)
          resolve(result)
        }, (err) => {
          if (settled) return
          settled = true
          clearTimeout(timer)
          reject(err)
        })
      })
    },
    // Retries fn() on failure with a fixed backoff between attempts. Only safe to use for
    // idempotent-ish calls (e.g. re-running an order finalize keyed off a known orderId).
    async retryWithBackoff (fn, attempts, delaysMs) {
      let lastError
      for (let i = 0; i < attempts; i++) {
        try {
          return await fn()
        } catch (e) {
          lastError = e
          const delay = delaysMs && delaysMs.length ? delaysMs[Math.min(i, delaysMs.length - 1)] : 0
          if (i < attempts - 1 && delay) {
            await this.sleep(delay)
          }
        }
      }
      throw lastError
    },
    // Leaves a trail in Sentry so a future occurrence of the stuck-receipt issue can be
    // diagnosed from production telemetry instead of requiring a local repro.
    addVivaBreadcrumb (message, data) {
      if (!this.$sentry || !this.$sentry.addBreadcrumb) return
      try {
        this.$sentry.addBreadcrumb({
          category: 'viva-recovery',
          message,
          level: 'info',
          data: Object.assign({
            shopId: this.shopId,
            vivaOrderNumber: this.vivaOrderNumber
          }, data || {})
        })
      } catch (e) {
        console.log('failed to add viva breadcrumb', e)
      }
    },
    captureVivaRecoveryIssue (label, error) {
      this.addVivaBreadcrumb(label, { error: error && (error.errorMessage || error.message) })
      if (!this.$sentry || !this.$sentry.captureException) return
      try {
        const reportedError = error instanceof Error ? error : new Error('viva-recovery: ' + label)
        this.$sentry.captureException(reportedError, {
          extra: {
            label,
            shopId: this.shopId,
            vivaOrderNumber: this.vivaOrderNumber,
            orderIds: this.orderIds,
            originalError: error && (error.errorMessage || error.message || error)
          }
        })
      } catch (e) {
        console.log('failed to report viva recovery issue to sentry', e)
      }
    }
  }
}
